import Modal from 'react-bootstrap/Modal'
import Container from '@material-ui/core/Container';

import SuccessPerson from '../../../assets/images/success-changes-person-icon.svg';
import IsvLogo from '../../../assets/images/isv.svg';


const SuccessfullModal = ({
    showModal,
    handleClickOKModal,
    handleClickCancelModal,
    clientData,
    selectedCountry,
    ShowSpecialModal,
    setShowModal,
}) => {
    const handleButtonOK = (e) => {
        e.preventDefault();
        handleClickOKModal();
    };
    return (
        <Modal
            size="lg"
            show={showModal}
            backdrop="static"
            keyboard={false}
        >
            <Modal.Body>
                <Container>
                    <br />
                    <div className="row d-flex justify-content-center" style={{ textAlign: 'justify' }}>
                        <img src={IsvLogo} alt="isv-logo" style={{ width: 210 }} />
                    </div>
                    <br />
                    <br />
                    <br />
                    {ShowSpecialModal !== false ? (
                    <div className="row d-flex justify-content-center" style={{ textAlign: 'justify' }}>
                        <img src={SuccessPerson} alt="success-person" />
                    </div>
                    ) : null}
                    <br />
                    <br />
                    <div className="row justify-content-center">
                        <h2 className="title-7">
                            <b>¡Perfecto!</b><br />
                            <b className="title-7 title-bold">Ya recibimos tus claves de forma segura.</b>
                        </h2>
                    </div>
                    <div className="row justify-content-center">
                    {ShowSpecialModal !== false ? (
                        <span className="text-3">
                            Nuestro equipo comenzará a descargar la información de tus portales. <br />
                            Este proceso finalizará en
                            {selectedCountry.impl_days && ['1', 1].includes(selectedCountry.impl_days) ? ` ${selectedCountry.impl_days} día ` : ` ${selectedCountry.impl_days || 'X'} días `}
                            y recibirás un correo de notificación. <br />
                            <br />
                        </span>
                    ) : null}
                    {ShowSpecialModal !== false? (
                        <span className="text-3 sub-text"> Si necesitas más información o tienes dudas comunícate al siguiente correo: <span className="text-3 sub-text text-bold">felipe.salazar@teamcore.cl</span>.</span>)
                        :<span className="text-3 sub-text"> Si necesitas más información o tienes dudas comunícate al siguiente correo: <span className="text-3 sub-text text-bold">karla.lucero@teamcore.cl</span>.</span>}
                    </div>
                    <br />
                    <br/>
                    <div className="row justify-content-center">
                        <button
                            className="isv-btn isv-btn-circle btn-warning btn-size-3 btn-block"
                            onClick={handleButtonOK}
                        >
                            Finalizar
                        </button>
                    </div>
                    <br />
                    <br/>
                </Container>
            </Modal.Body>
        </Modal>
    );
};

export default SuccessfullModal;
